/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api__routers__auth__UserResponse } from '../models/api__routers__auth__UserResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Google Login
     * Initiate Google OAuth flow.
     *
     * Redirects to Google's login page.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static googleLoginAuthGoogleGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/google',
        });
    }
    /**
     * Google Callback
     * Handle Google OAuth callback.
     *
     * Creates/updates user in database, creates JWT token, sets HttpOnly cookie.
     * Redirects to frontend dashboard.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static googleCallbackAuthCallbackGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/callback',
        });
    }
    /**
     * Exchange Auth Code
     * BP-086: Exchange a one-time auth code for a JWT cookie.
     *
     * Called by the Capacitor app after OAuth completes in the system browser.
     * The app receives `pamanagement://auth/callback?code=CODE` via deep link,
     * then navigates the WKWebView to this endpoint to set the HttpOnly cookie.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exchangeAuthCodeAuthExchangeGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/exchange',
        });
    }
    /**
     * Get Current User Info
     * Get current authenticated user info.
     *
     * Requires valid JWT token (cookie or header).
     * @returns api__routers__auth__UserResponse Successful Response
     * @throws ApiError
     */
    public static getCurrentUserInfoAuthMeGet(): CancelablePromise<api__routers__auth__UserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/me',
        });
    }
    /**
     * Logout
     * Logout by clearing the auth cookie.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logoutAuthLogoutPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/logout',
        });
    }
    /**
     * Auth Status
     * Check authentication status without requiring auth.
     *
     * Useful for frontend to check if user is logged in.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static authStatusAuthStatusGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/status',
        });
    }
    /**
     * Dev Login
     * Development-only login that bypasses OAuth.
     *
     * Only available when NOT in cloud environment (IS_CLOUD=false).
     * Creates a mock admin user for testing.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static devLoginAuthDevLoginGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/dev-login',
        });
    }
}
